import React, { PropsWithChildren } from 'react';
import {
  ApiCatalogLayout,
  BreadcrumbsProvider,
  NewRelicAgent,
} from '@internal/backstage-plugin-api-catalog';
import { breadcrumbDefinitions } from '../catalog/breadcrumbDefinition.ts';

export const Root = ({ children }: PropsWithChildren<{}>) => (
  <BreadcrumbsProvider breadcrumbDefinitions={breadcrumbDefinitions}>
    <NewRelicAgent />
    <ApiCatalogLayout>{children}</ApiCatalogLayout>
  </BreadcrumbsProvider>
);
